
const moduleData = {
  id: "module-8",
  title: "Module 8",
  subtitle: "Transition From Pravrtti to Nivritti orientation  through the path of Upasana in वानप्रस्थ(Vānaprastha)",
   cardImage: "/enBanner/m8_banner.jpg",
  pdfPath: "/en/Modules/m8.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m8.mp3",
    duration: "0:00"
  },
  video: {
    id: "tLZSe2bfNsI"
  },
  hero: {
    title: "Module 8",
    subtitle: "Transition From Pravrtti to Nivritti orientation  through the path of Upasana in वानप्रस्थ(Vānaprastha)",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m8_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Transition From Pravrtti to Nivritti orientation  through the path of Upasana in वानप्रस्थ(Vānaprastha)?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
          {
            question: "The term Vānaprastha literally means:",
            options: ["One who renounces the world", "One who dwells permanently in the forest", "One who proceeds towards the forest", "One who lives without possessions"],
            answer: "One who proceeds towards the forest"
          },
          {
            question: "What does a person give up during the Vanaprastha stage?",
            options: ["Wealth", "Desires and attachments", "Family", "Work"],
            answer: "Desires and attachments"
          },
          {
            question: "What is the purpose of the physical regulations in Vanaprastha?",
            options: ["To gain strength", "To destroy traits and establish concentration", "To lose weight", "To improve health"],
            answer: "To destroy traits and establish concentration"
          },
          {
            question: "According to Swami, Vānaprastha Āśrama primarily signifies:",
            options: ["Physical withdrawal into forests", "Abandonment of all responsibilities", "Gradual inner detachment while remaining socially responsible", "Complete renunciation of family life"],
            answer: "Gradual inner detachment while remaining socially responsible"
          },
          {
            question: "In Swamis teachings, the transition to Vānaprastha should begin when:",
            options: ["Old age physically weakens a person", "Desires are fully exhausted", "Major worldly duties are largely fulfilled", "One becomes dissatisfied with life"],
            answer: "Major worldly duties are largely fulfilled"
          },
          {
            question: "According to Swami, the most important preparation for Vānaprastha is:",
            options: ["Accumulation of wealth", "Study of rituals", "Control of senses and mind", "Isolation from society"],
            answer: "Control of senses and mind"
          },
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
